import { Box } from "@mui/material"
import { get } from "lodash"

import { BannerCTA, PreFooterCTA, ReviewsCTA } from ".."
import { PreFooterCtaComponents } from "../../graphql/types"

type PreFooterProps = {
  sliceContext?: {
    preFooterStyle7: {
      components: PreFooterCtaComponents[]
    }
  }
}

const PreFooterStyle7 = (props: React.PropsWithChildren<PreFooterProps>) => {
  const preFooter = get(props, "sliceContext.preFooterStyle7.components", [])
  if (!preFooter) return null

  return (
    <Box>
      {preFooter.map((data: any, i) => {
        switch (data?.type) {
          case "banner_cta":
            return <BannerCTA key={i} {...data} />
          case "reviews_cta":
            return <ReviewsCTA key={i} variation={data?.widget_type} {...data} />
          case "footer_cta":
            return <PreFooterCTA key={i} {...data} />
          default:
            return null
        }
      })}
    </Box>
  )
}

export default PreFooterStyle7
